// Website bundle : loaded on the portal pages by hooks.web_include_js
import "./qr.js";
import "./room3d.js";
import "./room3d_gl.js";
import "./ar_view.js";
import "./room_planner.js";
import "./configurator.js";
